"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../@hooks");
var _constants = require("../../@constants");
var _MenuTable = _interopRequireDefault(require("./components/MenuTable"));
var _AllTexts = _interopRequireDefault(require("./components/AllTexts"));
require("../../@assets/sass/components/PrivacyPolicy.scss");
function PrivacyPolicyPage(props) {
  var _useWhitelabel = (0, _hooks.useWhitelabel)(),
    loading = _useWhitelabel.loading,
    whitelabel = _useWhitelabel.whitelabel;
  var logoSrc = _constants.logosImages[props.app].logo;
  var logoAlt = _constants.logosImages[props.app].logoAlt;
  if (loading) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  var _ref = (whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel[props.app]) || {},
    _ref$emailDomain = _ref.emailDomain,
    emailDomain = _ref$emailDomain === void 0 ? 'taugor.com.br' : _ref$emailDomain;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "PrivacyPolicy ".concat(props.app)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "PrivacyPolicy-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "PrivacyPolicy-container-columnLeft"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: logoSrc,
    alt: logoAlt
  }), /*#__PURE__*/_react["default"].createElement(_MenuTable["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "PrivacyPolicy-container-columnRight"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "PrivacyPolicy-container-columnRight-title"
  }, "Pol\xEDtica de Privacidade Taugor - Abril de 2023"), /*#__PURE__*/_react["default"].createElement(_AllTexts["default"], {
    emailDomain: emailDomain
  }))));
}
var _default = PrivacyPolicyPage;
exports["default"] = _default;